{
  "name": "m1-drift",
  "seed": 1,
  "track": null,
  "fixedDtMs": 16.666666666666668,
  "cars": [{ "id": "player", "spawn": { "x": 240, "y": 360, "angle": 0 }, "ai": null }],
  "inputs": [
    { "frame": 0, "car": 0, "throttle": 1, "steer": 0, "handbrake": false },
    { "frame": 60, "car": 0, "steer": -1, "handbrake": true },
    { "frame": 95, "car": 0, "handbrake": false },
    { "frame": 110, "car": 0, "steer": 0 }
  ],
  "captures": [
    { "frame": 55, "name": "straight" },
    { "frame": 85, "name": "drift" },
    { "frame": 180, "name": "recover" }
  ]
}
